import { useEventListener } from "./armor-system-BB7ZV6HN.js";

// src/hooks/useNavigationControl.ts
import { useCallback } from "react";
var arrowKeyList = ["ArrowUp" /* ARROW_UP */, "ArrowDown" /* ARROW_DOWN */, "ArrowLeft" /* ARROW_LEFT */, "ArrowRight" /* ARROW_RIGHT */];

var useNavigationControl = function useNavigationControl(_ref) {
  var setCursorX = _ref.setCursorX,
    setCursorY = _ref.setCursorY,
    xLength = _ref.xLength,
    yLength = _ref.yLength,
    targetElement = _ref.targetElement,
    onNavigationKeyPress = _ref.onNavigationKeyPress,
    onEnterKeyPress = _ref.onEnterKeyPress,
    onEscapeKeyPress = _ref.onEscapeKeyPress,
    onOtherKeysPress = _ref.onOtherKeysPress,
    disabled = _ref.disabled;
  var getNextCursor = useCallback(function (currentCursor, key, limit) {
    if (!currentCursor && currentCursor !== 0 || !limit) {
      return 0;
    }
    switch (key) {
      case "ArrowUp" /* ARROW_UP */:
      case "ArrowLeft" /* ARROW_LEFT */:
        return currentCursor > 0 ? currentCursor - 1 : limit - 1;
      case "ArrowDown" /* ARROW_DOWN */:
      case "ArrowRight" /* ARROW_RIGHT */:
        return currentCursor < limit - 1 ? currentCursor + 1 : 0;
      default:
        break;
    }
    return 0;
  }, []);
  var handleArrowKeyPress = useCallback(function (key) {
    if (key === "ArrowLeft" /* ARROW_LEFT */ || key === "ArrowRight" /* ARROW_RIGHT */) {
      setCursorX == null ? void 0 : setCursorX(function (currentCursor) {
        return getNextCursor(currentCursor, key, xLength);
      });
    }
    if (key === "ArrowUp" /* ARROW_UP */ || key === "ArrowDown" /* ARROW_DOWN */) {
      setCursorY == null ? void 0 : setCursorY(function (currentCursor) {
        return getNextCursor(currentCursor, key, yLength);
      });
    }
  }, [setCursorX, setCursorY, getNextCursor, xLength, yLength]);
  var keyHandler = useCallback(function (event) {
    var key = event.key,
      target = event.target;
    if (target === targetElement.current) {
      if (arrowKeyList.includes(key)) {
        handleArrowKeyPress(key);
        onNavigationKeyPress == null ? void 0 : onNavigationKeyPress();
      } else if (key === "Enter" /* ENTER */) {
        onEnterKeyPress == null ? void 0 : onEnterKeyPress();
      } else if (key === "Escape" /* ESCAPE */) {
        onEscapeKeyPress == null ? void 0 : onEscapeKeyPress();
      } else {
        onOtherKeysPress == null ? void 0 : onOtherKeysPress();
      }
    }
  }, [handleArrowKeyPress, onEnterKeyPress, onEscapeKeyPress, onNavigationKeyPress, onOtherKeysPress, targetElement]);
  useEventListener("keydown", keyHandler, targetElement, disabled);
};
export { useNavigationControl };